<div fxLayout="row">
  <mat-icon class="color-grey-300 md-18" fxFlexAlign="center"
    >language</mat-icon
  >
  <nz-select
    [compareWith]="compareByCode"
    [nzDropdownMatchSelectWidth]="false"
    [nzSuffixIcon]="matIconArrowDown"
    [(ngModel)]="selectedLocale"
    (ngModelChange)="localeSwitched(selectedLocale.code)"
    class="color-grey-300"
    nzBorderless
  >
    @for (locale of supportedLocales; track locale.code) {
      <nz-option
        [nzLabel]="locale.bilingualName"
        [nzValue]="locale"
        nzCustomContent
      >
        {{ locale.bilingualName }}
        @if (locale.beta) {
          <span
            [ngStyle]="{ padding: '4px' }"
            class="bg-color-grey-100 color-grey text-caption u-borderRadius--4px"
            i18n="@@global.beta"
            >Beta</span
          >
        }
      </nz-option>
    }
  </nz-select>
</div>
<ng-template #matIconArrowDown>
  <mat-icon class="color-grey-300 md-18">keyboard_arrow_down </mat-icon>
</ng-template>
